/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskTypeEnum } from './taskTypeEnum';
import type { ExportedTaskInputTaskRef } from './exportedTaskInputTaskRef';
import type { ExportedTaskInputDescription } from './exportedTaskInputDescription';
import type { ExportedTaskInputObjectives } from './exportedTaskInputObjectives';
import type { ExportedTaskInputLevel } from './exportedTaskInputLevel';
import type { ExportedResourceInput } from './exportedResourceInput';
import type { ExportedTaskInputRubric } from './exportedTaskInputRubric';
import type { ExportedTaskInputEvaluation } from './exportedTaskInputEvaluation';

/**
 * Task export format
 */
export interface ExportedTaskInput {
  type: TaskTypeEnum;
  title: string;
  task_ref?: ExportedTaskInputTaskRef;
  description?: ExportedTaskInputDescription;
  objectives?: ExportedTaskInputObjectives;
  level?: ExportedTaskInputLevel;
  sort_index?: number;
  resources?: ExportedResourceInput[];
  rubric?: ExportedTaskInputRubric;
  evaluation?: ExportedTaskInputEvaluation;
}
